<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-4">
<h1>Chapter 4</h1>
<p>After leaving the crime scene, Languetti and Miles have taken their regular seats at Carmen’s Coffee House on Broadway. Florence, a long-time waitress at Carmen’s, brings over two cups of black coffee and places them on the table. Miles leans back and looks up at the waitress.</p>
<p>‘Hey Flo, can I please have a slice of your delicious Pecan pie?’</p>
<p>Flo winks at Miles.</p>
<p>‘Sure can, handsome.’</p>
<p>Flo looks over at Languetti. The grim look on his face visible.</p>
<p>‘Would you like some pie to cheer you up, Frank?’</p>
<p>Languetti looks up at Flo.</p>
<p>‘No, I’m not hungry, thanks anyway.’</p>
<p>‘Alrighty then, be back in a jiffy hun.’ Flo heads off. Both detectives sit quietly as they prepare their beverages. Frank has a sweet tooth and adds four sugar packets to his black coffee, Miles on the other hand, slowly stirs his coffee whilst adding a generous amount of cream. Flo promptly returns with a slice of Pecan pie and places it in front of Miles.</p>
<p>‘Here you go sweetness.’ Flo patting Miles on the shoulder as she leaves.</p>
<p>‘Thank-you-Flo.’ Miles rubs his palms together, inhaling the aroma of the roasted pecans. He wastes no time, taking possession of his fork, his mouth salivating at the thought. As he’s about to slice into the pie, Miles notices his partner eyeing his dessert, a reoccurring habit on Frank’s part when Miles orders pie. Miles glares directly at Frank.</p>
<p>‘Can I help you, Frank?’</p>
<p>‘What?’ Frank acts innocent. Miles shakes his head.</p>
<p>‘Why do you always do this Frank? Every time I order a piece of pie you stare at it like a sad hungry puppy.’ Frank leans back taking a sip of his coffee. Miles continues to rant.</p>
<p>‘I heard Flo ask you if you wanted a piece of pie, and! I also heard you say you weren’t hungry.’</p>
<p>Frank shrugs his shoulders.</p>
<p>‘I’m not hungry.’</p>
<p>‘Oh! you’re not hungry. Then quit staring at my pie, Frank.’</p>
<p>‘I’m not. Stop whining and just eat your pie.’ Languetti props himself upright, he looks across the diner, it’s quiet, only a few customers occupying tables.</p>
<p>‘I will. And I will enjoy every bite,’ Miles exclaims.</p>
<p>After a few moments of silence pass by, Languetti discreetly shifts his eyes back onto the dessert.</p>
<p>‘Can I just have little taste? A small piece, nothing too big.’ Miles lets out a sigh, dropping his fork onto the table.</p>
<p>‘Here.’ Miles slides the plate over to Languetti.</p>
<p>‘Take as much as you want Frank. Have it all, go on.’</p>
<p>Languetti manages a small grin.</p>
<p>‘I just want a little taste. I don’t understand why you’re so possessive. Sharing is healthy and good for the soul.’</p>
<p>Miles raises his coffee off the table.</p>
<p>‘A little taste.’ Miles shakes his head.</p>
<p>Without much hesitation, Languetti consumes a mouthful of Pecan pie. Miles just sits there sipping his coffee, peacefully, his thoughts to himself as he watches his partner unapologetically devour the whole dessert in minutes. Frank leans back into his chair and lets out a famished groan.</p>
<p>‘I’ll pay for the check tonight.’ Languetti grinning at Miles, Miles delivers a blank stare.</p>
<p>‘That was a really nice piece of pie,’ Languetti remarks. ‘You should get Flo to bring you a piece.’</p>
<p>Miles looks away.</p>
<p>‘Fuck you, Frank, I’m not hungry.’ He takes a mouthful of coffee, the hot liquid a welcomed relief as it consumes his chest.</p>
<p>Minutes pass by as both detectives enjoy their beverages in complete silence. Languetti looking past Miles’ shoulder at a young woman sitting at a table not too far from theirs. Her hair resembling the recent victim’s. Languetti’s facial expression quickly changes, the image of the bloodied young women invading his calm.</p>
<p>‘That fucker broke her ribs.’</p>
<p>Miles turns his attention to Languetti.</p>
<p>‘What was that?’</p>
<p>Languetti takes a sip of his coffee. ‘The woman, her ribs were broken.’</p>
<p>‘Yeah, I could hear the wheezing,’ Miles acknowledges. ‘Don’t worry about it, Frank, we got the son of a bitch now. He will get what’s coming to him.’</p>
<p>‘If she testifies.’ Languetti is quick to scrap his partner’s statement. ‘A guy who would do that to a woman, could just easily walk.’ Languetti taps his index finger on the table. ‘If she doesn’t press charges and testify, he walks. It’s that simple.’ Languetti takes his final mouthful of coffee placing his cup onto the table. ‘That never seems to bother you though. Why is that, Miles?’ Mile’s voice is tepid.</p>
<p>‘No Frank, it doesn’t because I don’t let it bother me.’ Miles adjusts himself, leaning forward onto the table.</p>
<p>‘That’s how you get ulcers and high blood pressure, Frank. I don’t get emotionally involved with the victim.’ Languetti looks right at Miles. ‘Is that what your Master’s in criminal psychology from NYU has taught you?’</p>
<p>Miles’ reply is confident.</p>
<p>‘Yes, Frank, it has. We have to worry about what we can control. We’re cops, not lawyers. I’m a new breed of cop, Frank. I tag ’em and bag ’em. The rest plays itself out.’</p>
<p>Languetti shows Miles the side of his face.</p>
<p>‘Maybe next time Frank, we can shoot the perp in the head, plant a gun and then call the black and whites to clean up.’ Miles leans back into his chair. ‘Will that make you happy, detective?’</p>
<p>Languetti waives dismissively, Miles slowly rises to his feet.</p>
<p>‘We have to evolve Frank. If we don’t, we become just like those assholes. Me, I’m better than that, and so are you Frank, so stop your bitching.’</p>
<p>Miles walks off, passing Flo on his way to the bathroom.</p>
<p>‘How was the pie handsome?’</p>
<p>Miles displays his resentment as he looks directly at Flo.</p>
<p>‘Next time I ask for pie, bring me two pieces, Flo.’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?45c5607a